import { supabase } from './supabase';
import { buildCertificateArchive, verifyRecoveredArchive } from './certificate-archive-export';
import { driveArchiveUrl } from './certificate-retention';

export const ARCHIVE_PAGE_SIZE = 50;

export async function listCertificateArchive({ page = 0, q = '', from = '', to = '', state = '' } = {}) {
  let query = supabase.from('v_certificate_archive').select('*', { count: 'exact' });
  const term = q.trim().replace(/[^\p{L}\p{N}\s_-]/gu, '').slice(0, 100);
  if (term) query = query.or(`certificate_number.ilike.%${term}%,client_name.ilike.%${term}%,service_order_code.ilike.%${term}%`);
  // Los históricos sin fecha documental se filtran por aprobación registrada;
  // el rótulo de pantalla explicita que NO es una fecha de emisión validada.
  if (from) query = query.gte('approved_at', `${from}T00:00:00-03:00`);
  if (to) {
    const next = new Date(`${to}T12:00:00Z`);
    next.setUTCDate(next.getUTCDate() + 1);
    query = query.lt('approved_at', `${next.toISOString().slice(0,10)}T00:00:00-03:00`);
  }
  if (state === 'pending') query = query.is('archive_confirmed_at', null);
  if (state === 'confirmed') query = query.not('archive_confirmed_at', 'is', null);
  if (state === 'held') query = query.not('hold_reason', 'is', null);
  if (state === 'candidate') query = query.eq('simulation_candidate', true);
  if (state === 'overdue') query = query.is('archive_confirmed_at', null).lte('purge_after', new Date().toISOString());
  const { data, count, error } = await query.order('approved_at', { ascending: false }).order('certificate_id')
    .range(page * ARCHIVE_PAGE_SIZE, (page + 1) * ARCHIVE_PAGE_SIZE - 1);
  if (error) throw error;
  return { rows: data || [], count: count || 0 };
}

export async function listArchiveBatches(page = 0) {
  const { data, count, error } = await supabase.from('certificate_archive_batches').select('*', { count: 'exact' })
    .order('created_at', { ascending: false }).order('id').range(page * 10, page * 10 + 9);
  if (error) throw error;
  return { rows: data || [], count: count || 0 };
}

export async function prepareCertificateExport(rows, onProgress) {
  const result = await buildCertificateArchive(rows, async (path) => {
    const { data, error } = await supabase.storage.from('certificates').download(path);
    if (error) throw new Error(`No se pudo descargar un original: ${error.message}. El lote no fue registrado.`);
    return data;
  }, onProgress);
  const { error } = await supabase.rpc('register_certificate_export', {
    p_batch_id: result.batchId, p_manifest: result.manifest, p_zip_sha256: result.zipHash, p_zip_bytes: result.blob.size,
  });
  if (error) throw error;
  return result;
}

export async function confirmArchiveBatch(batch, file, url, attested) {
  const driveUrl = driveArchiveUrl(url.trim());
  if (!driveUrl || !attested) throw new Error('Indicá la ubicación de Drive y confirmá que recuperaste el ZIP desde allí.');
  const hash = await verifyRecoveredArchive(file, batch);
  const { error } = await supabase.rpc('confirm_certificate_archive', {
    p_batch_id: batch.id, p_drive_url: driveUrl, p_recovered_zip_sha256: hash, p_attested: true,
  });
  if (error) throw error;
}

export async function changeArchiveHold(id, reason, release = false) {
  const { error } = await supabase.rpc('set_certificate_archive_hold', { p_certificate_id: id, p_reason: reason, p_release: release });
  if (error) throw error;
}
